<template>
    <div>
        <v-col cols="12">
            <v-alert
                v-if="informAlert == true"
                close-text="Close Alert"
                dense
                text
                type="success"
                dismissible
                style="text-align: left"
            >
                {{ informText }}
            </v-alert>

            <v-alert
                v-if="informAlert == false"
                close-text="Close Alert"
                dense
                text
                type="error"
                dismissible
                dark
                style="text-align: left"
            >
                {{ informText }}
            </v-alert>
        </v-col>

        <v-col cols="12" style="text-align: right">
            <v-btn color="success" @click="editItem();action = true">Create Warehouse Import</v-btn>
            &nbsp;
            <v-btn color="indigo" outlined @click.stop="drawer = !drawer">Filter Data</v-btn>
        </v-col>

        <v-col cols="12">
            <v-data-table
                :headers="headers"
                :items="listData"
                :options.sync="pagination"
                :server-items-length="totalItems"
                :loading="loading"
                class="elevation-1"
                item-key="order_id"
                :footer-props="{
                'items-per-page-options': [10, 20, 50, 100, 200, 500, 800, 1000],
                }"
            >
                <template v-slot:item.confirmation="{ item }">
                    <div>Delivered in full by: <b>{{ item.delivered_in_full_by }}</b></div>
                    <div>Received in full by:  <b>{{ item.received_in_full_by }}</b></div>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-btn
                        color="teal"
                        x-small
                        @click="exportItem(item)"
                        title="Export Batch Numbers"
                        v-if="roles.export_import_doc"
                    >
                        <v-icon small color="white"> mdi-export </v-icon>
                    </v-btn>
                    &nbsp;
                    <v-btn
                        color="primary"
                        x-small
                        @click="editItem(item);action = false"
                        v-if="roles.update_import_doc || roles.read_import_doc"
                    >
                        <v-icon small> mdi-pencil </v-icon>
                    </v-btn>
                    &nbsp;
                    <v-btn color="orange" x-small @click="deleteItem(item)" v-if="roles.delete_import_doc">
                        <v-icon color="white" small> mdi-delete </v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-col>

        <!-- Filter -->
        <v-navigation-drawer v-model="drawer" absolute right temporary>
        <v-list nav dense class="menu-scroll">
            <v-select
                :items="listWareHouse"
                :item-text="(obj) => obj.warehouse_code"
                :item-value="(obj) => obj.warehouse_code"
                label="Warehouse"
                dense
                outlined
                v-model="filterData.warehouseCode"
            ></v-select>
            
            <v-col cols="12">
            <!-- <v-btn @click.stop="drawer = false"  color="warning" fab x-small dark style="float:left">
                <v-icon class="fa fa-arrow-left"></v-icon>
            </v-btn>&nbsp; -->
            <v-btn
                @click="loadData"
                small
                outlined
                color="indigo"
                style="float: left"
                >Apply</v-btn
            >
            <v-btn
                @click="reset"
                small
                outlined
                color="indigo"
                style="float: right"
                >Reset</v-btn
            >
            </v-col>
        </v-list>
        </v-navigation-drawer>

        <BaseDialog :active.sync="dialogEdit" dialog_name="Warehouse Import Action">
            <WarehouseEdit
                :selectedItem="selected"
                :warehouseList="listWareHouse"
                :rawMaterialList="listRawMaterials"
                :action="action"
                :roles="roles"
            />
        </BaseDialog>

        
    </div>
</template>

<script>
    import axios from "axios";
    import moment from "moment-timezone"
    import Amplify, { Auth } from "aws-amplify";
    import BaseDialog from "../../Common/c-base-dialog";
    import WarehouseEdit from "./c-warehouse-import-dialog-edit.vue"

    Amplify.configure({
        Auth: {
            region: "ap-southeast-1",
            userPoolId: "ap-southeast-1_8vBdk5PAd",
            userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
            mandatorySignIn: true,
        },
    });

    export default {
        name:"warehouseImport",

        components:{
            BaseDialog,
            WarehouseEdit
        },

        data:() => ({
            
            roles: [],
            search: "",
            loading: false,
            informText: "",
            informAlert: null,

            dialogEdit: false,
            selected:null,
            action: false,

            listData:[],
            listStatus: [],
            listWareHouse: [],
            listRawMaterials:[],

            pagination: {
            page: 1,
            itemsPerPage: 10,
            sortBy: [],
            sortDesc: [],
            groupBy: false,
            groupDesc: false,
            multiSort: false,
            mustSort: false,
            },

            drawer: false,
            filterData:{
                warehouseCode:'',
            },

            totalItems:0,

            headers: [
                { text: "Created At", value: "created_at" },
                { text: "Created By", value: "created_by" },
                { text: "Warehouse", value: "warehouse_code" },
                { text: "Sender", value: "sender" },
                { text: "Note", value: "note", width:"15%" },
                { text: "Received By", value: "received_in_full_by" },
                { text: "Total Batches", value: "total_batches" },
                { text: "Total Products", value: "total_products" },
                { text: "Actions", value: "actions", sortable: false },
            ],
        }),

        created() {
            this.$root.$refs.warehouseImport = this;
        },
                
        watch: {
            pagination: {
                handler() {
                    let queryParams = this.getParams();
                    this.$router
                    .push({ path: "warehouse-import", query: queryParams })
                    .catch((err) => {
                        var error = err.toString();
                        if (!error.includes("redundant navigation")) {
                        throw err;
                        }
                    });
                    console.log("pagination");
                    this.loadData();
                },
                deep: true,
            },
        },

        methods:{
            getParams() {
                let queryParams = {
                    page: this.pagination.page,
                    itemsPerPage: this.pagination.itemsPerPage,
                    sortBy: this.pagination.sortBy[0],
                    sortDesc: this.pagination.sortDesc[0],
                };

                if(this.filterData.warehouseCode != ''){
                    queryParams['warehouseCode'] = this.filterData.warehouseCode
                }

                return queryParams;
            },

            async loadData(){
                this.loading = true;
                let queryParams = this.getParams();

                var currentSession = await this.$root.$refs.App.currentSession(
                    "warehouseExport-loadData"
                );

                if (currentSession.accessToken) {
                    await axios
                    .get(window.domain + "warehouse-import?", {
                        headers: { Authorization: currentSession.accessToken },
                        params: queryParams,
                    })
                    .then((response) => {
                        // console.log(this.AuthStr)
                        console.log(response);
                        this.totalItems = response.data.data.marchingExportDocs
                        this.listData = response.data.data.warehouseImportDocs;
                        this.listStatus = response.data.data.statuses;
                        this.listWareHouse = response.data.data.warehouses;
                        this.listRawMaterials = response.data.data.raw_materials;

                        console.log("this.listData: ",this.listData)

                        this.listData.map(t => {
                            t.created_at = moment(t.created_at).format("DD/MMM/YYYY - HH:mm:ss");
                            //t.confirmed_at = moment(t.confirmed_at).format("DD/MMM/YYYY - HH:mm:ss");
                            return t;
                        });
                        
                        this.loading = false;
                    })
                    .catch((error) => {
                        console.log("Error:", error);
                        this.loading = false;
                        this.listData = [];
                    });
                } else {
                    console.log("undefined warehouseExport-loadData-undefined: ",currentSession);
                }
            },

            async exportItem(item){
                console.log("item: ",item)
                this.loading = true
                var currentSession = await this.$root.$refs.App.currentSession(
                    "warehouseExport-exportCSV"
                    );
                    if (currentSession.accessToken) {
                        await fetch(window.domain + "warehouse-import/export/" + item._id, {
                            method: "POST",
                            headers: { Authorization: currentSession.accessToken },
                        })
                        .then((response) => response.json())
                        .then(data => {
                            console.log('data: ',data)
                            if(data.error_message != ''){
                                this.informText = data.error_message
                                this.informAlert = false
                            }else{
                                this.informText = "We're currently preprocessing your order data. System will send a file to your email when completed."
                                this.informAlert = true
                            }
                            this.loading = false
                        })
                        .catch((error) => {
                        console.log("Error:", error);
                        });
                    } else {
                    console.log("currentSession warehouseExport-exportCSV-undefined: ", currentSession);
                    }
            },

            editItem(item){
                console.log("item: ",item)
                this.selected = item;
                this.dialogEdit = !this.dialogEdit;
            },

            async deleteItem(item){
                const index = this.listData.indexOf(item);
                var r =
                    confirm("Are you to delete this item?") &&
                    this.listData.splice(index, 1);
                if (r != false) {
                    var currentSession = await this.$root.$refs.App.currentSession(
                    "warehouseExport-delete"
                    );
                    if (currentSession.accessToken) {
                        axios.delete(window.domain + "warehouse-import/" + item._id, {
                        headers: { Authorization: currentSession.accessToken },
                        })
                        .then((response) => console.log("warehouseExport-delete: ", response))
                        .catch((error) => {
                        console.log("Error:", error);
                        });
                    } else {
                    console.log("currentSession warehouseExport-delete-undefined: ", currentSession);
                    }
                }
            },

            reset() {
                this.filterData = {warehouseCode:""};
            },

            turnOffDialog(){
                this.dialogEdit = false;
            }
        },

        async mounted(){
            this.roles = await this.$cookies.get("warehouse_import");
            if (this.roles.list_import_docs) {
                console.log("OK");
            } else {
                this.$router.push("/not-authorized");
            }
            
            try {
                await Auth.currentAuthenticatedUser({ bypassCache: false });
                this.loadData();
            } catch (error) {
                console.log("User logged out!");
                this.$router.push("/login");
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>